import { UnUploadedImage } from "components/PhotoUpload/types";

export const isSelectedImageDuplicate = (image: UnUploadedImage, toUpload: UnUploadedImage[]) =>
    toUpload.find((v) => v.base64 === image.base64);